const de = {
  "Provider costs": "Anbieterkosten",
  "AiProviderAdministration.MenuTitle": "KI-Anbieter",
  "AiProviderAdministration.ProviderTab": "Anbieter",
  "AiProviderAdministration.ModelsTab": "Modelle",
  "AiProviderAdministration.AgentsTab": "Agenten",
  "AiProviderAdministration.CostsTab": "Anbieterkosten",
  "ProviderCost.MixedCurrencies": "Mehrere Währungen — Beträge werden getrennt ausgewiesen",
  "ProviderCost.UnknownCurrency": "ohne Währungsangabe",
  "ProviderCost.TenantTab": "nach Mandant",
  "ProviderCost.TenantColumn": "Mandant",
  "ProviderCost.UnknownCosts": "Unbekannte Kosten",
  "ProviderCost.StaleCosts": "Veraltete Kosten",
  "ProviderCost.IncompleteCosts": "Die Kostensumme ist unvollständig",
  "ProviderAccess.CacheWritePerMillion": "Cache-Schreibvorgänge pro Million",
  "ProviderAccess.UnitPrice": "Einheitspreis",
  "ProviderAccess.ContextThreshold": "ab Tokens",
  "ProviderAccess.Official": "offiziell",
  "ProviderAccess.Internal": "intern",
  "ProviderAccess.Current": "aktuell",
  "ProviderAccess.Stale": "veraltet",
  "ProviderAccess.UpdateRequired": "Preisaktualisierung erforderlich",
  "ProviderAccess.InternalConfigurationRequired": "interne Kostenbasis erforderlich",
  "ProviderAccess.BillingModelUnsupported": "Kosten nicht berechenbar",
  "ProviderAccess.InternalCostConfiguration": "interne Kostenbasis bearbeiten",
  "ProviderAccess.ExistingInternalCostConfiguration": "vorhandene Kostenbasis",
  "ProviderAccess.NewInternalCostConfiguration": "neue Kostenbasis",
  "ProviderAccess.ExactModelOrWorkflow": "Exakte Modell- oder Workflow-ID",
  "ProviderAccess.ServiceTier": "Tarifstufe",
  "ProviderAccess.CostType": "Kostenart",
  "ProviderAccess.Unit": "Einheit",
  "ProviderAccess.Amount": "Betrag",
  "ProviderAccess.Currency": "Währung",
  "ProviderAccess.CalculationBasis": "Kalkulationsgrundlage",
  "ProviderAccess.EffectiveFrom": "gültig ab",
  "ProviderAccess.DatePlaceholder": "Datum",
  "ProviderAccess.TimePlaceholder": "Uhrzeit",
  "ProviderAccess.InputTokens": "Input-Tokens",
  "ProviderAccess.CachedInputTokens": "gecachte Input-Tokens",
  "ProviderAccess.CacheWriteTokens": "Cache-Schreibvorgänge",
  "ProviderAccess.CacheWrite1HourTokens": "Cache-Schreibvorgänge (1 Stunde)",
  "ProviderAccess.OutputTokens": "Output-Tokens",
  "ProviderAccess.UnitCost": "Einheit",
  "ProviderAccess.ExecutionTime": "Rechenzeit",
  "ProviderAccess.OperationChat": "Chat",
  "ProviderAccess.OperationImage": "Bild",
  "ProviderAccess.OperationEmbedding": "Embedding",
  "ProviderAccess.OperationClassification": "Klassifikation",
  "ProviderAccess.OperationVideo": "Video",
  "ProviderAccess.OperationSpeech": "Sprache",
  "ProviderAccess.OperationTranscription": "Transkription",
  "ProviderAccess.OperationMusic": "Musik",
  "ProviderAccess.OperationSoundEffect": "Soundeffekt",
  "Internal provider cost saved": "Interne Kostenbasis gespeichert.",
} as const;

const en = {
  "Provider costs": "Provider costs",
  "AiProviderAdministration.MenuTitle": "AI providers",
  "AiProviderAdministration.ProviderTab": "Providers",
  "AiProviderAdministration.ModelsTab": "Models",
  "AiProviderAdministration.AgentsTab": "Agents",
  "AiProviderAdministration.CostsTab": "Provider costs",
  "ProviderCost.MixedCurrencies": "Several currencies — amounts are reported separately",
  "ProviderCost.UnknownCurrency": "no currency recorded",
  "ProviderCost.TenantTab": "By tenant",
  "ProviderCost.TenantColumn": "Tenant",
  "ProviderCost.UnknownCosts": "Unknown costs",
  "ProviderCost.StaleCosts": "Stale costs",
  "ProviderCost.IncompleteCosts": "The cost total is incomplete",
  "ProviderAccess.CacheWritePerMillion": "Cache writes per million",
  "ProviderAccess.UnitPrice": "Unit price",
  "ProviderAccess.ContextThreshold": "from tokens",
  "ProviderAccess.Official": "official",
  "ProviderAccess.Internal": "internal",
  "ProviderAccess.Current": "current",
  "ProviderAccess.Stale": "stale",
  "ProviderAccess.UpdateRequired": "Price update required",
  "ProviderAccess.InternalConfigurationRequired": "Internal cost basis required",
  "ProviderAccess.BillingModelUnsupported": "Cost cannot be calculated",
  "ProviderAccess.InternalCostConfiguration": "Edit internal cost basis",
  "ProviderAccess.ExistingInternalCostConfiguration": "Existing cost basis",
  "ProviderAccess.NewInternalCostConfiguration": "New cost basis",
  "ProviderAccess.ExactModelOrWorkflow": "Exact model or workflow ID",
  "ProviderAccess.ServiceTier": "Service tier",
  "ProviderAccess.CostType": "Cost type",
  "ProviderAccess.Unit": "Unit",
  "ProviderAccess.Amount": "Amount",
  "ProviderAccess.Currency": "Currency",
  "ProviderAccess.CalculationBasis": "Calculation basis",
  "ProviderAccess.EffectiveFrom": "Effective from",
  "ProviderAccess.DatePlaceholder": "Date",
  "ProviderAccess.TimePlaceholder": "Time",
  "ProviderAccess.InputTokens": "Input tokens",
  "ProviderAccess.CachedInputTokens": "Cached input tokens",
  "ProviderAccess.CacheWriteTokens": "Cache writes",
  "ProviderAccess.CacheWrite1HourTokens": "Cache writes (1 hour)",
  "ProviderAccess.OutputTokens": "Output tokens",
  "ProviderAccess.UnitCost": "Unit",
  "ProviderAccess.ExecutionTime": "Compute time",
  "ProviderAccess.OperationChat": "Chat",
  "ProviderAccess.OperationImage": "Image",
  "ProviderAccess.OperationEmbedding": "Embedding",
  "ProviderAccess.OperationClassification": "Classification",
  "ProviderAccess.OperationVideo": "Video",
  "ProviderAccess.OperationSpeech": "Speech",
  "ProviderAccess.OperationTranscription": "Transcription",
  "ProviderAccess.OperationMusic": "Music",
  "ProviderAccess.OperationSoundEffect": "Sound effect",
  "Internal provider cost saved": "Internal cost basis saved.",
} as const;

const ru = {
  "Provider costs": "Затраты на провайдеров",
  "AiProviderAdministration.MenuTitle": "Поставщики ИИ",
  "AiProviderAdministration.ProviderTab": "Поставщики",
  "AiProviderAdministration.ModelsTab": "Модели",
  "AiProviderAdministration.AgentsTab": "Агенты",
  "AiProviderAdministration.CostsTab": "Затраты на поставщиков",
  "ProviderCost.MixedCurrencies": "Несколько валют — суммы показаны раздельно",
  "ProviderCost.UnknownCurrency": "без указания валюты",
  "ProviderCost.TenantTab": "По арендатору",
  "ProviderCost.TenantColumn": "Арендатор",
  "ProviderCost.UnknownCosts": "Неизвестные затраты",
  "ProviderCost.StaleCosts": "Устаревшие затраты",
  "ProviderCost.IncompleteCosts": "Общая сумма затрат неполна",
  "ProviderAccess.CacheWritePerMillion": "Записи в кеш за миллион",
  "ProviderAccess.UnitPrice": "Цена за единицу",
  "ProviderAccess.ContextThreshold": "от токенов",
  "ProviderAccess.Official": "официально",
  "ProviderAccess.Internal": "внутренне",
  "ProviderAccess.Current": "актуально",
  "ProviderAccess.Stale": "устарело",
  "ProviderAccess.UpdateRequired": "Требуется обновление цены",
  "ProviderAccess.InternalConfigurationRequired": "Требуется внутренняя база затрат",
  "ProviderAccess.BillingModelUnsupported": "Стоимость не рассчитывается",
  "ProviderAccess.InternalCostConfiguration": "Изменить внутреннюю базу затрат",
  "ProviderAccess.ExistingInternalCostConfiguration": "Существующая база затрат",
  "ProviderAccess.NewInternalCostConfiguration": "Новая база затрат",
  "ProviderAccess.ExactModelOrWorkflow": "Точный ID модели или процесса",
  "ProviderAccess.ServiceTier": "Тарифный уровень",
  "ProviderAccess.CostType": "Тип затрат",
  "ProviderAccess.Unit": "Единица",
  "ProviderAccess.Amount": "Сумма",
  "ProviderAccess.Currency": "Валюта",
  "ProviderAccess.CalculationBasis": "Основа расчёта",
  "ProviderAccess.EffectiveFrom": "Действует с",
  "ProviderAccess.DatePlaceholder": "Дата",
  "ProviderAccess.TimePlaceholder": "Время",
  "ProviderAccess.InputTokens": "Входные токены",
  "ProviderAccess.CachedInputTokens": "Кешированные входные токены",
  "ProviderAccess.CacheWriteTokens": "Записи в кеш",
  "ProviderAccess.CacheWrite1HourTokens": "Записи в кеш (1 час)",
  "ProviderAccess.OutputTokens": "Выходные токены",
  "ProviderAccess.UnitCost": "Единица",
  "ProviderAccess.ExecutionTime": "Время вычислений",
  "ProviderAccess.OperationChat": "Чат",
  "ProviderAccess.OperationImage": "Изображение",
  "ProviderAccess.OperationEmbedding": "Эмбеддинг",
  "ProviderAccess.OperationClassification": "Классификация",
  "ProviderAccess.OperationVideo": "Видео",
  "ProviderAccess.OperationSpeech": "Речь",
  "ProviderAccess.OperationTranscription": "Транскрипция",
  "ProviderAccess.OperationMusic": "Музыка",
  "ProviderAccess.OperationSoundEffect": "Звуковой эффект",
  "Internal provider cost saved": "Внутренняя база затрат сохранена.",
} as const;

const uk = {
  "Provider costs": "Витрати на постачальників",
  "AiProviderAdministration.MenuTitle": "Постачальники ШІ",
  "AiProviderAdministration.ProviderTab": "Постачальники",
  "AiProviderAdministration.ModelsTab": "Моделі",
  "AiProviderAdministration.AgentsTab": "Агенти",
  "AiProviderAdministration.CostsTab": "Витрати на постачальників",
  "ProviderCost.MixedCurrencies": "Кілька валют — суми показано окремо",
  "ProviderCost.UnknownCurrency": "без зазначення валюти",
  "ProviderCost.TenantTab": "За орендарем",
  "ProviderCost.TenantColumn": "Орендар",
  "ProviderCost.UnknownCosts": "Невідомі витрати",
  "ProviderCost.StaleCosts": "Застарілі витрати",
  "ProviderCost.IncompleteCosts": "Загальна сума витрат неповна",
  "ProviderAccess.CacheWritePerMillion": "Записи в кеш на мільйон",
  "ProviderAccess.UnitPrice": "Ціна за одиницю",
  "ProviderAccess.ContextThreshold": "від токенів",
  "ProviderAccess.Official": "офіційно",
  "ProviderAccess.Internal": "внутрішньо",
  "ProviderAccess.Current": "актуально",
  "ProviderAccess.Stale": "застаріло",
  "ProviderAccess.UpdateRequired": "Потрібне оновлення ціни",
  "ProviderAccess.InternalConfigurationRequired": "Потрібна внутрішня база витрат",
  "ProviderAccess.BillingModelUnsupported": "Вартість не розраховується",
  "ProviderAccess.InternalCostConfiguration": "Редагувати внутрішню базу витрат",
  "ProviderAccess.ExistingInternalCostConfiguration": "Наявна база витрат",
  "ProviderAccess.NewInternalCostConfiguration": "Нова база витрат",
  "ProviderAccess.ExactModelOrWorkflow": "Точний ID моделі або процесу",
  "ProviderAccess.ServiceTier": "Тарифний рівень",
  "ProviderAccess.CostType": "Тип витрат",
  "ProviderAccess.Unit": "Одиниця",
  "ProviderAccess.Amount": "Сума",
  "ProviderAccess.Currency": "Валюта",
  "ProviderAccess.CalculationBasis": "Основа розрахунку",
  "ProviderAccess.EffectiveFrom": "Діє з",
  "ProviderAccess.DatePlaceholder": "Дата",
  "ProviderAccess.TimePlaceholder": "Час",
  "ProviderAccess.InputTokens": "Вхідні токени",
  "ProviderAccess.CachedInputTokens": "Кешовані вхідні токени",
  "ProviderAccess.CacheWriteTokens": "Записи в кеш",
  "ProviderAccess.CacheWrite1HourTokens": "Записи в кеш (1 година)",
  "ProviderAccess.OutputTokens": "Вихідні токени",
  "ProviderAccess.UnitCost": "Одиниця",
  "ProviderAccess.ExecutionTime": "Час обчислень",
  "ProviderAccess.OperationChat": "Чат",
  "ProviderAccess.OperationImage": "Зображення",
  "ProviderAccess.OperationEmbedding": "Ембединг",
  "ProviderAccess.OperationClassification": "Класифікація",
  "ProviderAccess.OperationVideo": "Відео",
  "ProviderAccess.OperationSpeech": "Мовлення",
  "ProviderAccess.OperationTranscription": "Транскрипція",
  "ProviderAccess.OperationMusic": "Музика",
  "ProviderAccess.OperationSoundEffect": "Звуковий ефект",
  "Internal provider cost saved": "Внутрішню базу витрат збережено.",
} as const;

const it = {
  "Provider costs": "Costi dei fornitori",
  "AiProviderAdministration.MenuTitle": "Fornitori IA",
  "AiProviderAdministration.ProviderTab": "Fornitori",
  "AiProviderAdministration.ModelsTab": "Modelli",
  "AiProviderAdministration.AgentsTab": "Agenti",
  "AiProviderAdministration.CostsTab": "Costi dei fornitori",
  "ProviderCost.MixedCurrencies": "Più valute — gli importi sono indicati separatamente",
  "ProviderCost.UnknownCurrency": "senza valuta indicata",
  "ProviderCost.TenantTab": "Per tenant",
  "ProviderCost.TenantColumn": "Tenant",
  "ProviderCost.UnknownCosts": "Costi sconosciuti",
  "ProviderCost.StaleCosts": "Costi obsoleti",
  "ProviderCost.IncompleteCosts": "Il totale dei costi è incompleto",
  "ProviderAccess.CacheWritePerMillion": "Scritture cache per milione",
  "ProviderAccess.UnitPrice": "Prezzo unitario",
  "ProviderAccess.ContextThreshold": "da token",
  "ProviderAccess.Official": "ufficiale",
  "ProviderAccess.Internal": "interno",
  "ProviderAccess.Current": "attuale",
  "ProviderAccess.Stale": "obsoleto",
  "ProviderAccess.UpdateRequired": "Aggiornamento del prezzo richiesto",
  "ProviderAccess.InternalConfigurationRequired": "Base di costo interna richiesta",
  "ProviderAccess.BillingModelUnsupported": "Costo non calcolabile",
  "ProviderAccess.InternalCostConfiguration": "Modifica base di costo interna",
  "ProviderAccess.ExistingInternalCostConfiguration": "Base di costo esistente",
  "ProviderAccess.NewInternalCostConfiguration": "Nuova base di costo",
  "ProviderAccess.ExactModelOrWorkflow": "ID esatto del modello o workflow",
  "ProviderAccess.ServiceTier": "Livello di servizio",
  "ProviderAccess.CostType": "Tipo di costo",
  "ProviderAccess.Unit": "Unità",
  "ProviderAccess.Amount": "Importo",
  "ProviderAccess.Currency": "Valuta",
  "ProviderAccess.CalculationBasis": "Base di calcolo",
  "ProviderAccess.EffectiveFrom": "Valido dal",
  "ProviderAccess.DatePlaceholder": "Data",
  "ProviderAccess.TimePlaceholder": "Ora",
  "ProviderAccess.InputTokens": "Token di input",
  "ProviderAccess.CachedInputTokens": "Token di input in cache",
  "ProviderAccess.CacheWriteTokens": "Scritture cache",
  "ProviderAccess.CacheWrite1HourTokens": "Scritture cache (1 ora)",
  "ProviderAccess.OutputTokens": "Token di output",
  "ProviderAccess.UnitCost": "Unità",
  "ProviderAccess.ExecutionTime": "Tempo di calcolo",
  "ProviderAccess.OperationChat": "Chat",
  "ProviderAccess.OperationImage": "Immagine",
  "ProviderAccess.OperationEmbedding": "Embedding",
  "ProviderAccess.OperationClassification": "Classificazione",
  "ProviderAccess.OperationVideo": "Video",
  "ProviderAccess.OperationSpeech": "Voce",
  "ProviderAccess.OperationTranscription": "Trascrizione",
  "ProviderAccess.OperationMusic": "Musica",
  "ProviderAccess.OperationSoundEffect": "Effetto sonoro",
  "Internal provider cost saved": "Base di costo interna salvata.",
} as const;

export const sharedProviderPricingDe = de;
export const sharedProviderPricingEn = en;
export const sharedProviderPricingRu = ru;
export const sharedProviderPricingUk = uk;
export const sharedProviderPricingIt = it;

export const sharedProviderPricingTranslations = { de, en, ru, uk, it } as const;
export type SharedProviderPricingLang = keyof typeof sharedProviderPricingTranslations;
export type SharedProviderPricingKey = keyof typeof de;
